import { render } from "./manualOcr.vue?vue&type=template&id=40c54754&scoped=true"
import script from "./manualOcr.vue?vue&type=script&lang=js"
export * from "./manualOcr.vue?vue&type=script&lang=js"

import "./manualOcr.vue?vue&type=style&index=0&id=40c54754&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c54754"]])

export default __exports__